import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DownloadItemTab from './TabPanels/DownloadItemTab';

const DownloadCategoryBundlePopup = ({
  category,
  categoryBundle,
  onClose,
}) => {
  const [selectedTab, setSelectedTab] = useState(() => {
    if (categoryBundle.renderBundleUrl) {
      return 'render';
    }
    if (categoryBundle.videoBundleUrl) {
      return 'video';
    }
    return 'empty';
  });
  const [renderResolutions] = useState(() => (categoryBundle.renderBundleUrl ? [
    {
      type: 'sd',
      src: categoryBundle.renderBundleUrl.replace('_md.zip', '_sd.zip'),
      description: 'Calidad BÁSICA - Recomendado para redes sociales',
    },
    {
      type: 'md',
      src: categoryBundle.renderBundleUrl,
      description: 'Calidad MEDIA - Recomendado para web',
    },
    {
      type: 'hd',
      src: categoryBundle.renderBundleUrl.replace('_md.zip', '_hd.zip'),
      description: 'Calidad ALTA - Recomendado para catálogos o pantallas gran formato',
    },
  ] : []));

  const getSelectedTab = () => {
    switch (selectedTab) {
      case 'render':
        return <DownloadItemTab resolutions={renderResolutions} />;
      case 'video':
        return (
          <React.Fragment>
            <div className="title-download">Puedes descargar todos los videos a continuación:</div>
            <div className="form video-download">
              <button
                type="button"
                className="submit enabled"
                onClick={() => window.open(categoryBundle.videoBundleUrl, '_self')}
              >Descargar
              </button>
            </div>
          </React.Fragment>
        );
      default:
        return null;
    }
  };
  return (
    <div className="download-category-bundle-popup-container">
      <div className="download-popup">
        <div className="header">
          <div className="title">
            <div className="category">{category}</div>
            <span>|</span>Descargar contenido completo
          </div>
          <button type="button" className="close-button" aria-label="Close" onClick={onClose} />
        </div>
        <div className="content">
          <div className="navigation">
            {categoryBundle.renderBundleUrl ? (
              <button
                type="button"
                className={`render${selectedTab === 'render' ? ' selected' : ''}`}
                aria-label="Render"
                onClick={() => setSelectedTab('render')}
              >RENDERS
              </button>
            ) : null}
            {categoryBundle.videoBundleUrl ? (
              <button
                type="button"
                className={`video${selectedTab === 'video' ? ' selected' : ''}`}
                aria-label="Video"
                onClick={() => setSelectedTab('video')}
              >VIDEOS
              </button>
            ) : null}
          </div>
          <div className="divider" />
          {getSelectedTab()}
        </div>
      </div>
    </div>
  );
};

DownloadCategoryBundlePopup.propTypes = {
  category: PropTypes.string.isRequired,
  categoryBundle: PropTypes.shape({
    category: PropTypes.string,
    renderBundleUrl: PropTypes.string,
    videoBundleUrl: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DownloadCategoryBundlePopup;
